export default () => ({
  apiEndpoint: '',
  isFetchingMergeRequests: false,
  hasErrorFetchingMergeRequests: false,
  mergeRequests: [],
  totalCount: 0,
});
